import { useEffect, useState } from "react";
import "./Schedule.css";
import { Trans, useTranslation } from "react-i18next";
import {
  fetchWeeklySchedule,
  fetchCollectives,
  getImageUrl,
} from "../api/strapi";
import WeekdayItem from "./ScheduleComponents/WeekdayItem";
import { useNavigate } from "react-router";
import { Loader } from "react-feather";

function Schedule() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState([]);
  const [weeklySchedule, setWeeklySchedule] = useState();
  const [collectives, setCollectives] = useState([]);

  const weekdayEnglish = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const monthEnglish = [
    "January",
    "Febuary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    /* 
            The code fetches events from the API using the https://radar.squat.net/api/1.2/search/events.json?facets[group][]=22747&fields=*&facets[group][]=22748 query. 
            The numbers 22747 and 22748 refer to the Grote Broek and Onderbroek respectively.
            It then processes the fetched JSON data, sorts the events based on their date time and sets the sorted events in the setEvents function.
        */
    fetch(
      "https://radar.squat.net/api/1.2/search/events.json?facets[group][]=22747&fields=*&facets[group][]=22748&limit=20",
    )
      .then((response) => response.json())
      .then((json) => {
        let eventsObject = json.result;
        let eventsArray = [];
        for (var event in eventsObject) {
          eventsArray.push(eventsObject[event]);
        }
        eventsArray.sort(function (a, b) {
          return a.date_time[0].value - b.date_time[0].value;
        });
        setEvents(eventsArray);
      })
      .catch((_) => {
        setEvents([]);
      });

    fetchWeeklySchedule(i18n.language)
      .then((data) => {
        setWeeklySchedule(data);
      })
      .catch((_) => {
        setWeeklySchedule([]);
      });

    fetchCollectives(i18n.language)
      .then((data) => {
        console.log(data);
        setCollectives(data);
      })
      .catch((_) => {
        setCollectives([]);
      });
  }, [i18n.language]);

  function getDateString(date) {
    return (
      weekdayEnglish[date.getDay()] +
      " " +
      date.getDate() +
      " " +
      monthEnglish[date.getMonth()]
    );
  }

  function getTimeString(date, enddate) {
    return `${date.toLocaleTimeString([], {
      hourCycle: "h23",
      hour: "2-digit",
      minute: "2-digit",
    })} - ${enddate.toLocaleTimeString([], {
      hourCycle: "h23",
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  }

  function getLocationString(locationString) {
    if (locationString.toLowerCase().includes("klinker")) return "🍽️ Klinker";
    if (locationString.toLowerCase().includes("onderbroek"))
      return "🩲 Onderbroek";
    return "Unknown";
  }

  if (weeklySchedule != null) {
    return (
      <>
        <div
          className="modalcontent cursor-pointer opt-out-pointers mt-8"
          onClick={() => navigate("/buy-de-broek-fundraiser")}
        >
          <span class="breakingtitle opt-out-pointers">
            <Trans i18nKey="acquisition.bannertitle">UNDER CONSTRUCTION</Trans>
          </span>
          <marquee
            className="marquee opt-out-pointers"
            behavior="scroll"
            direction="left"
          >
            <Trans i18nKey="acquisition.bannertext">
              BEEP BOOP, OUR BASEMENT CRITTERS ARE HARD AT WORK BUILDING AND
              MAINTAINING THIS WEBSITE. EVERYTHING IS WORK IN PROGRESS! PLEASE
              REPORT ANY PROBLEMS TO INFO@GROTEBROEK.NL. DUTCH AND ENGLISH
              TRANSLATIONS WILL BE ADDED SOON!
            </Trans>
          </marquee>
        </div>

        <div className="my-12">
          <h2 className="text-4xl font-bold">
            <Trans i18nKey="schedule.communitytitle">COMMUNITY</Trans>
          </h2>
          <span className="text-xl">
            <Trans i18nKey="schedule.communitydesc">
              De Grote Broek is a community-ran project combining a living
              collective, activist offices, venue and social centre in the city
              centre of Nijmegen. We host volunteer-ran, donation-based events
              and pride ourselves on non-hierarchical organising. Make this
              building your own and meet the collectives!
            </Trans>
          </span>
          <div class="mt-4 grid grid-flow-row grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-1 collective-grid">
            {collectives.map((collective, i) => {
              return (
                <div
                  className="cursor-pointer"
                  onClick={() => navigate("/" + collective.linkname)}
                >
                  <img
                    className="rounded-t-lg w-64 h-32 object-cover"
                    src={getImageUrl(collective.cover.url)}
                  ></img>
                  <div className="m-2">
                    <span className="font-bold text-base block">
                      {collective.name}
                    </span>
                    <span className="font-extralight italic text-base block">
                      {collective.category}
                    </span>
                    <p className="mt-2 font-light text-base leading-4">
                      {collective.small_description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <h2 className="text-4xl mt-12 py-4 font-bold text-center opt-out-pointers underline">
          <Trans i18nKey="schedule.weeklytitle">WEEKLY SCHEDULE</Trans>
        </h2>

        <div className="grid md:grid-cols-3 grid-cols-1 gap-4 schedule-grid">
          <WeekdayItem
            dayName={"Monday"}
            events={weeklySchedule["Monday"].Events}
          ></WeekdayItem>
          <WeekdayItem
            dayName={"Tuesday"}
            events={weeklySchedule["Tuesday"].Events}
          ></WeekdayItem>
          <WeekdayItem
            dayName={"Wednesday"}
            events={weeklySchedule["Wednesday"].Events}
          ></WeekdayItem>
          <WeekdayItem
            dayName={"Thurday"}
            events={weeklySchedule["Thursday"].Events}
          ></WeekdayItem>
          <WeekdayItem
            dayName={"Friday"}
            events={weeklySchedule["Friday"].Events}
          ></WeekdayItem>
          <WeekdayItem
            dayName={"Saturday"}
            events={weeklySchedule["Saturday"].Events}
          ></WeekdayItem>
          <WeekdayItem
            dayName={"Sunday"}
            events={weeklySchedule["Sunday"].Events}
          ></WeekdayItem>
        </div>

        <h2 className="text-4xl mt-12 font-bold text-center opt-out-pointers underline">
          <Trans i18nKey="schedule.upcomingtitle">UPCOMING EVENTS</Trans>
        </h2>
        {events.length < 1 && (
          <div className="m-8 text-center italic text-3xl animate-bounce">
            <span>
              <Loader className=" inline-block"></Loader> LOADING EVENTS
            </span>
          </div>
        )}
        <div id="parent">
          {events.map((event, i) => {
            return (
              <>
                <div className="flex py-6 flex-col-reverse md:flex-row" key={i}>
                  <div className="flex-none w-64 flex flex-col font-medium text-[18px] md:text-[24px] uppercase pr-8">
                    <span>
                      {getDateString(new Date(event.date_time[0].time_start))}
                    </span>
                    <span>
                      {getTimeString(
                        new Date(event.date_time[0].time_start),
                        new Date(event.date_time[0].time_end),
                      )}
                    </span>
                    <span>
                      {event.title &&
                        getLocationString(event.og_group_ref[0].title)}
                    </span>
                  </div>
                  <div className="flex-none md:flex-auto">
                    <div>
                      <a
                        href={event.url}
                        className="font-bold text-[32px] md:text-[48px] uppercase leading-none"
                      >
                        {event.title}
                      </a>
                    </div>
                    <div>
                      {event.category[0] ? (
                        <a
                          href={event.url}
                          className="font-bold text-[20px] uppercase leading-none"
                        >
                          {event.category[0].name}
                        </a>
                      ) : (
                        <a
                          href={event.url}
                          className="font-bold text-[20px] uppercase leading-none"
                        >
                          event
                        </a>
                      )}
                      {/* <a href={events[key].url} className='font-bold text-[20px] uppercase leading-none'>{events[key].category[0].name}</a> */}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </>
    );
  } else {
    return (
      <>
        <h2 className="text-4xl py-4 font-bold text-center opt-out-pointers italic">
          RETRIEVING THE SCHEDULE
        </h2>
        <div className=" text-center mt-16">
          <div class="spinner inline-block">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </>
    );
  }
}

export default Schedule;
